(function () {
  "use strict";

  $(document).ready(function () {
    $(".tab-row").hide();
    $(".tab-row:first").show();

    // Click su elementi li mode tab bar
    $("ul.nav-tab li").click(function () {
      $("ul.nav-tab li").removeClass("active");
      $(this).addClass("active");

      $(".tab-row").hide();
      var activeTab = $(this).attr("rel");
      $("#" + activeTab).fadeIn();
    });
  }); // close document get ready
})(jQuery);
